import React, { useState, useEffect } from 'react';
import { db } from '../firebase-config';
import { doc, getDoc } from 'firebase/firestore';
import styles from './TermsAndCondition.module.css';



const TermsAndConditions = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const docRef = doc(db, 'siteContent', 'terms');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().text && docSnap.data().text.trim() !== "") {
          setContent(docSnap.data().text);
        } else {
          setContent('');
        }
      } catch (error) {
        setContent('');
      }
    };
    fetchTerms();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-[#d49814] mb-6 text-center">Terms and Conditions</h1>
      <div
        className={styles.cmsContent}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default TermsAndConditions;